import { ChangeDetectionStrategy, Component, Inject, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { ModuleAccessLevel } from '@fi-shared/access-right-filters/module-access-level';
import { AccessRightFilterCollectionModel, ILightWeightObject } from '@fi-shared/models';

@Component({
    selector: 'data-field-edit-cluster',
    template: `
        <div class="form-group full-width-material">
            <fi-select-search
                [items]="lightWeightClusters"
                [(ngModel)]="dataFieldObject.ClusterId"
                [label]="'common.cluster' | fiAppText"
                [disabled]="!isEnabled()"
                [required]="dataField.IsSetRequired"
                name="cluster-select"
                [errorText]="'error_message.required_dropdown' | fiAppText"
            >
            </fi-select-search>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'data-field-edit-cluster' },
    standalone: false,
})
export class DataFieldEditClusterComponent extends DataFieldEditBase implements OnInit {
    lightWeightClusters: ILightWeightObject[];
    accessRightFilterCollection: AccessRightFilterCollectionModel;

    constructor(
        @Inject('lightWeightClusters') lightWeightClusters: ILightWeightObject[],
        @Inject('accessRightFilterCollection') accessRightFilterCollection: AccessRightFilterCollectionModel,
        injector: Injector,
    ) {
        super(injector);
        this.lightWeightClusters = lightWeightClusters;
        this.accessRightFilterCollection = accessRightFilterCollection;
    }

    ngOnInit() {}

    isEnabled(): boolean {
        return this.accessRightFilterCollection.AccessLevel >= ModuleAccessLevel.Local;
    }
}
